var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserDefault2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.03226,
    y: 1.03226,
    width: 61.9355,
    height: 61.9355,
    rx: 30.9677,
    fill: "url(#paint0_linear_194_3704)",
    stroke: "url(#paint1_linear_194_3704)",
    strokeWidth: 2.06452
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_194_3704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5269 10.3225C37.5367 10.3225 42.4087 15.1945 42.4087 21.2043C42.4087 27.2142 37.5367 32.0862 31.5269 32.0862C25.517 32.0862 20.645 27.2142 20.645 21.2043C20.645 15.1945 25.517 10.3225 31.5269 10.3225ZM27.1636 24.0676C27.0431 24.0676 26.9448 24.1659 26.9448 24.2864C26.945 26.6962 28.8992 28.6497 31.3091 28.6497H31.7446C34.1545 28.6497 36.1087 26.6962 36.1089 24.2864C36.1089 24.1659 36.0106 24.0676 35.8901 24.0676H27.1636Z",
    fill: "url(#paint2_linear_194_3704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4194 42.8387C13.4194 37.4227 17.8099 33.0322 23.2259 33.0322H40.7743C46.1902 33.0322 50.5807 37.4227 50.5807 42.8387V42.8387C50.5807 48.2546 46.1902 52.6451 40.7743 52.6451H23.2259C17.8099 52.6451 13.4194 48.2546 13.4194 42.8387V42.8387Z",
    fill: "url(#paint3_linear_194_3704)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_194_3704",
    x: 11.7013,
    y: 10.3225,
    width: 40.5975,
    height: 45.7591,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.71818
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.85909
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.230492 0 0 0 0 0.335608 0 0 0 0 0.44391 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_194_3704"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_194_3704",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_194_3704",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528846,
    stopColor: "#C3D1E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A97A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_194_3704",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3D8EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_194_3704",
    x1: 31.5269,
    y1: 10.3225,
    x2: 31.5269,
    y2: 32.0862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_194_3704",
    x1: 32.0001,
    y1: 33.0322,
    x2: 32.0001,
    y2: 52.6451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDDBE9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDefault2);
export default __webpack_public_path__ + "static/media/user-default-2.7b10ecb00082fbfb86fba0446591d2d4.svg";
export { ForwardRef as ReactComponent };